// @core/api/endpoints/tenant/approve_tenant_migration.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ApproveTenantMigrationRequest,
  TenantMigrationResponse,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Approve tenant migration
 * Approves a pending migration request. Requires platform admin privileges. Once approved, the migration can be started.
 */
export async function ApproveTenantMigration(
  tenant_id: string,
  migration_id: string,
  data: ApproveTenantMigrationRequest,
  options?: RequestOptions
): Promise<TenantMigrationResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/migration/:migration_id/approve`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  requestPath = requestPath.replace(':migration_id', encodeURIComponent(migration_id));
  const requestOptions = options;
  return client.post<TenantMigrationResponse>(requestPath, data, requestOptions);
}
